import { Button } from "@/components/flexkit/Button";
import { InputField } from "@/components/podkit/forms/InputField";
import { DeleteAccountModal } from "@/components/settings/profile/DeleteAccountModal";
import { useGetAccount } from "@/queries/account-queries";
import { useState, type FC } from "react";

export const DeleteAccount: FC = () => {
    // Explicitly not handling loading/error states for account/user as that's taken care of in AuthenticatedUserLayout
    const { data: account } = useGetAccount();
    const [open, setOpen] = useState(false);

    if (!account) {
        return;
    }

    return (
        <>
            <InputField label="Delete account" hint="Permanently delete your Gitpod account">
                <Button
                    variant="destructive"
                    className="w-fit"
                    onClick={() => setOpen(true)}
                    data-testid="delete-account-btn"
                >
                    Delete Account
                </Button>
            </InputField>
            <DeleteAccountModal account={account} open={open} onClose={() => setOpen(false)} />
        </>
    );
};
